import React, { Fragment, useState } from 'react'
import { Col, Row } from 'reactstrap'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import Select from 'react-select';
import { demo, hsjs, insan, sharp } from '../../../constant/globalConstantsTypeClients';




export const IndexSidebar = (props) => {


    const {

        // * ACTIONS OF THE INPUTS
        handleInputChangeWorkOrder,
        checkPrint,
        checkEmail,
        handleCheckEmail,
        handleCheckWhatsChange,
        checkWhats,
        checkDoctor,
        handleCheckDoctor,
        checkWhatsdoctor,
        handleCheckWhatsDoctorChange,
        enable_whatsapp,


        // * LIST INFORMATION
        observations,
        observations_sample,
        informationDoctor,

        // * DELIVERY TIME
        minDate,
        handleApply,
        handleAutoSave,
        study_delivery,

        // * COMENTS
        checkComments,
        enableComments,
        observations_general,
        ShowClassNameC,

        // * SAMPLE
        enable_tracking_toma,

        // * SAVE IN EDITING
        isSaved,
        customSelectStyles1,
        id_printer_point,
        listPrinterPoint,
        handleSelectValuesWorkOrder,
        PlaceHolderOption,

        // * HISTORIC WORK ORDER
        isEditWorkOrder,
        handleViewHistoric,
        dataHistorical,

        //* HOSPITALIZED
        hospitalized,

        hospitalization_comment,

        dataHistoricalHospitality,
        handleViewHistoricHospitality,
        handleHospitalizedChange


    } = props;




    // ! VALIDATION
    const isPacienteActive = checkPrint || checkEmail || checkWhats;
    const isDoctorActive = checkDoctor;
    const [printerOpen, setPrinterOpen] = useState(false);
    const [hospitalizationOpen, setHospitalizationOpen] = useState(true);
    const [observationsOpen, setObservationsOpen] = useState(true);
    const [deliveryOpen, setDeliveryOpen] = useState(true);

	const url_helen = localStorage.getItem("url_helen");

    // ! SCROLL
    const autoResize = (e) => {
        const el = e.target;
        el.style.height = "auto";
        el.style.height = el.scrollHeight + "px";
    };






    return (
    <>
        {
            //* HISTORY ORDER
        }
        {
            isEditWorkOrder && dataHistorical?.length > 0 && (
                <div className={`sidebar-card sidebar-section sidebar-section-action ${ isSaved ? "saved" : "" }`} onClick={handleViewHistoric}>
                    <div className="sidebar-section-header">
                        <div className="sidebar-section-left">
                            <div className="sidebar-section-icon sidebar-section-icon-badge">
                                <i className="fa fa-history"></i>

                                {dataHistorical?.length > 0 && (
                                    <span className="sidebar-section-badge">
                                        {dataHistorical.length}
                                    </span>
                                )}
                            </div>

                            <div className="sidebar-section-info">
                                <span className="sidebar-section-title">
                                    HISTÓRICO DE LA ORDEN
                                </span>
                            </div>
                        </div>

                        <div className="sidebar-section-arrow-action">
                            <i className="fa fa-angle-right"></i>
                        </div>
                    </div>
                </div>
            )
        }


        {
            //* PRINTING POINT
        }
        <div className={`sidebar-card printer-card ${isSaved ? "saved" : ""}`}>

            <button type="button" className={`printer-collapse-header ${ printerOpen ? "open" : ""}`} onClick={() => setPrinterOpen(prev => !prev)}>
                <div className="printer-collapse-left">
                    <div className="printer-collapse-icon">
                        <i className="fa fa-print"></i>
                    </div>

                    <div className="history-order-info">

                        <span className="history-order-title">
                            PUNTO DE IMPRESIÓN
                        </span>

                        {!printerOpen && (
                            <span className="printer-collapse-value">
                                {id_printer_point?.label || "Seleccionar impresora"}
                            </span>
                        )}

                    </div>
                </div>

                <div className={`printer-collapse-arrow ${ printerOpen ? "open" : "" }`}>
                    <i className="fa fa-chevron-down"></i>
                </div>
            </button>

            <div className={`printer-collapse-content ${ printerOpen ? "open" : ""}`}>
                <div className="printer-collapse-inner">
                    <Select
                        styles={customSelectStyles1}
                        name="id_printer_point"
                        value={id_printer_point}
                        options={listPrinterPoint}
                        onChange={(e) =>
                            handleSelectValuesWorkOrder(
                                e,
                                "id_printer_point"
                            )
                        }
                        placeholder={PlaceHolderOption}
                        isClearable
                    />
                </div>
            </div>
        </div>


        {
            //* HOSPITALIZATION
        }

        {(url_helen === insan || url_helen === sharp || url_helen === demo || url_helen === hsjs) && (
            <div className={`sidebar-card emergency-card ${hospitalized === true || hospitalized === 1 ? "active" : "" } ${isSaved ? "saved" : ""}`}>
                <div className={`hospital-collapse-header ${hospitalizationOpen ? "open" : ""  }`}>
                    <div className="hospital-collapse-left"
                        onClick={() => {

                            if (hospitalized === true || hospitalized === 1) {
                                setHospitalizationOpen(prev => !prev);
                            }

                        }}
                    >
                        <div className={`emergency-icon emergency-icon-action ${ dataHistoricalHospitality?.length > 0 ? "has-history" : "" }`}
                            onClick={(e) => {
                                e.stopPropagation();
                                if (dataHistoricalHospitality?.length > 0) {
                                    handleViewHistoricHospitality();
                                }
                            }}
                            title={
                                dataHistoricalHospitality?.length > 0
                                    ? "Ver histórico de hospitalizaciones"
                                    : "Sin histórico de hospitalizaciones"
                            }
                        >

                            <i className="fa fa-hospital-o"></i>

                            {dataHistoricalHospitality?.length > 0 && (
                                <span className="emergency-history-badge">
                                    {dataHistoricalHospitality.length}
                                </span>
                            )}

                        </div>

                        <div className="emergency-title">
                            <span className="emergency-label">
                                HOSPITALIZACIÓN
                            </span>

                            {/* <span className="history-order-title">
                                {hospitalized === true || hospitalized === 1
                                    ? "Paciente hospitalizado"
                                    : "Paciente no hospitalizado"}

                            </span> */}
                        </div>
                    </div>

                    <div className="hospitalization-header-actions">
                        <label className={`hospitalization-switch ${ hospitalized === true || hospitalized === 1 ? "active" : "" }`} onClick={(e) => e.stopPropagation()}>
                            <input
                                type="checkbox"
                                name="hospitalized"
                                checked={
                                    hospitalized === true ||
                                    hospitalized === 1
                                }
                                onChange={async (e) => {
                                    const checked = e.target.checked;
                                    await handleHospitalizedChange(e);
                                    setHospitalizationOpen(checked);
                                }}
                            />

                            <span className="hospitalization-switch-track">
                                <span className="hospitalization-switch-circle">
                                    {(hospitalized === true ||
                                        hospitalized === 1) && (
                                        <i className="fa fa-check"></i>

                                    )}
                                </span>
                            </span>
                        </label>

                        {(hospitalized === true || hospitalized === 1) && (
                            <div
                                className={`hospital-collapse-arrow ${
                                    hospitalizationOpen ? "open" : ""
                                }`}
                                onClick={() =>
                                    setHospitalizationOpen(prev => !prev)
                                }
                            >
                                <i className="fa fa-chevron-down"></i>
                            </div>
                        )}
                    </div>
                </div>

                {(hospitalized === true || hospitalized === 1) && (
                    <div
                        className={`hospital-collapse-content ${
                            hospitalizationOpen ? "open" : ""
                        }`}
                    >
                        <div className="hospital-collapse-inner">
                            <div className="hospitalization-active-content">
                                <div className="observation-group">
                                    <textarea
                                        name="hospitalization_comment"
                                        className="textarea-modern emergency-textarea"
                                        rows="3"
                                        placeholder="Describa el motivo de hospitalización..."
                                        onChange={handleInputChangeWorkOrder}
                                        value={hospitalization_comment || ""}
                                    />

                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        )}

        {
            //* OBSERVATIONS 
        }
        <div className={`sidebar-card sidebar-section ${ isSaved ? "saved" : "" }`}>
            <button type="button" className={`sidebar-section-header ${ observationsOpen ? "open" : ""}`} onClick={() => setObservationsOpen(prev => !prev) }>
                <div className="sidebar-section-left">
                    <div className="sidebar-section-icon">
                        <i className="fa fa-commenting-o"></i>
                    </div>

                    <div className="sidebar-section-info">
                        <span className="sidebar-section-title">
                            OBSERVACIONES
                        </span>
                    </div>
                </div>

                <div className={`sidebar-section-arrow ${ observationsOpen ? "open" : "" }`}>
                    <i className="fa fa-chevron-down"></i>
                </div>
            </button>

            <div className={`sidebar-section-content ${ observationsOpen ? "open" : "" }`}>
                <div className="sidebar-section-content-wrapper">
                    <div className="sidebar-section-inner">
                        <div className="observation-group">
                            <textarea
                                name="observations"
                                className="textarea-modern"
                                rows="3"
                                placeholder="Trabajo del día..."
                                onChange={handleInputChangeWorkOrder}
                                value={observations}
                            />

                            {
                                enable_tracking_toma === "True" && (
                                    <textarea
                                        name="observations_sample"
                                        className="textarea-modern"
                                        rows="3"
                                        placeholder="Flebotomía..."
                                        onChange={handleInputChangeWorkOrder}
                                        value={observations_sample}
                                    />

                                )
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>

        {
            //* DELIVERY OF RESULTS
        }
        <div className={`sidebar-card sidebar-section ${isSaved ? "saved" : ""}`}>
            <button
                type="button"
                className={`sidebar-section-header ${
                    deliveryOpen ? "open" : ""
                }`}
                onClick={() =>
                    setDeliveryOpen(prev => !prev)
                }
            >
                <div className="sidebar-section-left">
                    <div className="sidebar-section-icon">
                        <i className="fa fa-send"></i>
                    </div>

                    <div className="sidebar-section-info">
                        <span className="sidebar-section-title">
                            ENTREGA DE RESULTADOS
                        </span>
                    </div>
                </div>

                <div className={`sidebar-section-arrow ${deliveryOpen ? "open" : "" }`}>
                    <i className="fa fa-chevron-down"></i>
                </div>
            </button>

            <div className={`sidebar-section-content ${deliveryOpen ? "open" : ""}`}>
                <div className="sidebar-section-content-wrapper">
                    <div className="sidebar-section-inner">
                        <div className="delivery-section">
                            <div className="config-panel pt-0">
                                <Row className="channels-inline">
                                    <Col xs="12" className="channel-row">
                                        <Col sm="12" className="date-row">
                                            <div className={`channel-label ${isPacienteActive ? "active" : ""}`}>
                                                <i className="fa fa-user"></i>
                                                PACIENTE
                                            </div>

                                            <div className="channel-actions">
                                                <label className="channel-btn print" title="Impreso">
                                                    <input
                                                        type="checkbox"
                                                        checked={checkPrint}
                                                        name="checkPrint"
                                                        onChange={
                                                            handleInputChangeWorkOrder
                                                        }
                                                    />

                                                    <div className="circle">
                                                        <i className="fa fa-print f-14"></i>
                                                        <span className="mini-check"></span>
                                                    </div>
                                                </label>

                                                <label className="channel-btn blue" title="Correo">
                                                    <input
                                                        type="checkbox"
                                                        checked={checkEmail}
                                                        onChange={
                                                            handleCheckEmail
                                                        }
                                                    />

                                                    <div className="circle">
                                                        <i className="fa fa-envelope f-14"></i>
                                                        <span className="mini-check"></span>
                                                    </div>
                                                </label>


                                                {
                                                    enable_whatsapp === "True" && (

                                                        <label className="channel-btn blue" title="Whatsapp">
                                                            <input
                                                                type="checkbox"
                                                                name="checkWhats"
                                                                onChange={
                                                                    handleCheckWhatsChange
                                                                }
                                                                checked={
                                                                    checkWhats
                                                                }
                                                            />

                                                            <div className="circle">
                                                                <i className="fa fa-whatsapp f-14"></i>
                                                                <span className="mini-check"></span>
                                                            </div>
                                                        </label>
                                                    )
                                                }
                                            </div>
                                        </Col>
                                    </Col>

                                    {
                                        informationDoctor.length > 0 && (
                                            <Col xs="12" className="channel-row" >
                                                <Col sm="12" className="date-row">
                                                    <div
                                                        className={`channel-label ${
                                                            isDoctorActive
                                                                ? "active"
                                                                : ""
                                                        }`}
                                                    >
                                                        <i className="fa fa-stethoscope"></i>
                                                        MÉDICO
                                                    </div>

                                                    <div className="channel-actions">
                                                        <label className="channel-btn purple" title="Correo">
                                                            <input
                                                                type="checkbox"
                                                                checked={
                                                                    checkDoctor
                                                                }
                                                                onChange={
                                                                    handleCheckDoctor
                                                                }
                                                            />

                                                            <div className="circle">
                                                                <i className="fa fa-envelope f-14"></i>
                                                                <span className="mini-check"></span>
                                                            </div>
                                                        </label>
                                                    </div>
                                                </Col>
                                            </Col>
                                        )
                                    }
                                </Row>
                            </div>
                        </div>

                        {
                            //* DELIVERY TIME
                        }
                        <div className="delivery-section delivery-time-section">
                            <div className="date-row">
                                <div className="date-input-wrapper">
                                    <i className="pi pi-calendar"></i>
                                    <DateRangePicker
                                        initialSettings={{
                                            singleDatePicker: true,
                                            showDropdowns: true,
                                            minDate: minDate,
                                            timePicker: true,
                                            timePicker24Hour: true,
                                            drops: "up",
                                            opens: "right",

                                            locale: {
                                                format: "YYYY-MM-DD HH:mm",
                                                applyLabel: "Aceptar",
                                                cancelLabel: "Cancelar",

                                                daysOfWeek: [
                                                    "Dom",
                                                    "Lun",
                                                    "Mar",
                                                    "Mié",
                                                    "Jue",
                                                    "Vie",
                                                    "Sáb"
                                                ],

                                                monthNames: [
                                                    "Enero",
                                                    "Febrero",
                                                    "Marzo",
                                                    "Abril",
                                                    "Mayo",
                                                    "Junio",
                                                    "Julio",
                                                    "Agosto",
                                                    "Septiembre",
                                                    "Octubre",
                                                    "Noviembre",
                                                    "Diciembre"
                                                ],
                                            },
                                        }}
                                        onApply={handleApply}
                                        onChange={handleAutoSave}
                                        onHide={handleAutoSave}
                                    >

                                        <input
                                            type="text"
                                            readOnly
                                            className={`date-input ${
                                                study_delivery
                                                    ? "has-value"
                                                    : ""
                                            }`}
                                            value={study_delivery}
                                            placeholder="Fecha de entrega"
                                        />

                                    </DateRangePicker>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
);
}
